import api, { initialiseCsrf } from "./httpClient";
import { API_PATHS } from "./apiPaths";

// Revoke the HttpOnly browser session before callers clear any local UI state.
// A rejection means the caller must keep the current auth state intact so the
// browser cannot appear logged out while the backend session is still active.
export const revokeBrowserSession = async () => {
  await initialiseCsrf({ force: true });
  return api.post(API_PATHS.auth.logout, undefined, { withCredentials: true });
};

